import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import SelectBlock from '../../../components/SelectBlock';
import Constants from '../../../../constants/constants';

const getUserSections = (isAdmin) => [
  {
    key: 'personal-information',
    label: 'Personal Information',
  },
  {
    key: 'account-information',
    label: 'Company Information',
  },
  ...(isAdmin
    ? [
        {
          key: 'change-password',
          label: 'Change Password',
        },
      ]
    : []),
  {
    key: 'credentials',
    label: 'Credentials',
  },
];

const UserMobileNavigation = ({ userId, userProfile, auth, onViewLogs }) => {
  const history = useHistory();
  const location = useLocation();
  const userSections = getUserSections(auth && auth.isAdmin);
  const currentSection = userSections.find((section) => location.pathname.includes(`/user-profile/${section.key}/`)) || userSections[0];
  const sectionOptions = userSections.map((section) => ({
    value: section.key,
    label: section.label,
  }));
  const selectedSection = sectionOptions.find((option) => option.value === currentSection.key);
  const fullName = [userProfile.firstName, userProfile.lastName].filter(Boolean).join(' ');
  const usernameOrEmail = userProfile.username || userProfile.email;

  const navigateToSection = (selectedOption) => {
    if (selectedOption) {
      history.push(`/management/user-profile/${selectedOption.value}/${userId}`);
    }
  };

  return (
    <section className='aes-user-mobile-navigation d-lg-none' aria-labelledby='aes-user-mobile-navigation-title'>
      <div className='aes-user-mobile-navigation__summary'>
        <div className='aes-user-mobile-navigation__identity flex-column align-items-start'>
          {userProfile.imageUrl && (
            <div className='aes-user-mobile-navigation__avatar symbol symbol-50'>
              <div
                className='symbol-label background-image-container'
                style={{ backgroundImage: `url(${Constants.API_URL + userProfile.imageUrl})` }}
                aria-hidden='true'
              />
              <i className='symbol-badge bg-success' aria-hidden='true' />
            </div>
          )}
          <div className='aes-user-mobile-navigation__name'>
            <span className='aes-user-mobile-navigation__eyebrow'>User Profile</span>
            <h2 id='aes-user-mobile-navigation-title' className='font-size-h3 font-weight-boldest'>
              {fullName || 'User'}
            </h2>
            {userProfile.roles && <p>{userProfile.roles}</p>}
          </div>
        </div>
      </div>

      <div className='aes-user-mobile-navigation__details'>
        {usernameOrEmail && (
          <div className='aes-user-mobile-navigation__detail'>
            <span>{userProfile.username ? 'Username' : 'Email'}</span>
            <strong>{usernameOrEmail}</strong>
          </div>
        )}
        {userProfile.username && userProfile.email && (
          <div className='aes-user-mobile-navigation__detail'>
            <span>Email</span>
            <strong>{userProfile.email}</strong>
          </div>
        )}
        {userProfile.phoneNumber && (
          <div className='aes-user-mobile-navigation__detail'>
            <span>Phone</span>
            <strong>{userProfile.phoneNumber}</strong>
          </div>
        )}
        {userProfile.location && (
          <div className='aes-user-mobile-navigation__detail'>
            <span>Location</span>
            <strong>{userProfile.location}</strong>
          </div>
        )}
      </div>

      <div className='aes-user-mobile-navigation__actions'>
        <button
          type='button'
          className='aes-user-mobile-navigation__logs btn btn-sm btn-primary font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1'
          disabled={!(auth && auth.isAdmin)}
          onClick={onViewLogs}
        >
          Logs
        </button>
      </div>

      <SelectBlock
        label='Current section'
        className='aes-user-mobile-navigation__select'
        selectClassNamePrefix='aes-user-navigation-select'
        containerClassName='aes-user-mobile-navigation__select-container'
        options={sectionOptions}
        value={selectedSection}
        onChange={navigateToSection}
        isSearchable={false}
        menuPortalTarget={document.body}
        menuPosition='fixed'
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 1060 }),
        }}
      />
    </section>
  );
};

export default UserMobileNavigation;
